import { getRouteApi, useNavigate } from '@tanstack/react-router';
import { useCallback } from 'react';

import { FoodDetailScreen } from './FoodDetailScreen';
import type { FoodDetailTab } from './food-detail-search';

const route = getRouteApi('/foods/$foodId');

export function FoodDetailRoute() {
  const { foodId } = route.useParams();
  const { tab } = route.useSearch();
  const navigate = useNavigate();

  /**
   * A merge re-points the page at the survivor. `replace` so the back button
   * returns to the catalog rather than to the row that no longer exists.
   */
  const onOpenFood = useCallback(
    (next: string) => {
      void navigate({
        to: '/foods/$foodId',
        params: { foodId: next },
        search: { tab: 'details' },
        replace: true,
      });
    },
    [navigate],
  );

  const onTabChange = useCallback(
    (next: FoodDetailTab) => {
      void navigate({ to: '/foods/$foodId', params: { foodId }, search: { tab: next } });
    },
    [navigate, foodId],
  );

  const onOpenEvent = useCallback(
    (key: string) => {
      void navigate({ to: '/catalog-changes', search: { window: 'all', event: key } });
    },
    [navigate],
  );

  const onOpenRequest = useCallback(
    (requestId: string) => {
      void navigate({ to: '/food-requests/$requestId', params: { requestId } });
    },
    [navigate],
  );

  return (
    <FoodDetailScreen
      foodId={foodId}
      tab={tab}
      onOpenFood={onOpenFood}
      onTabChange={onTabChange}
      onOpenEvent={onOpenEvent}
      onOpenRequest={onOpenRequest}
    />
  );
}
